module.exports = __webpack_public_path__ + "static/media/retinal-scan-illustration.a9bef696.png";